import React from 'react';
import { Database, Landmark, PenLine, Clock } from 'lucide-react';

const SOURCES = [
  { icon: Database, name: 'Polygon.io', what: 'Stock, ETF and options prices, options trades and news' },
  { icon: Landmark, name: 'Federal Reserve, BLS and U.S. Treasury data (via Polygon.io)', what: 'Treasury yields, inflation and labor-market readings' },
  { icon: PenLine, name: 'OpenAI GPT-4o', what: 'Writes the explanations; numbers are checked against the data' },
];

export const TrustStrip = () => (
  <section className="mk-trust" aria-labelledby="data-sources-title" data-testid="trust-strip">
    <div className="mk-container">
      <div className="mk-trust-row">
        <h2 id="data-sources-title" className="mk-trust-title">Data sources</h2>
        <ul className="mk-trust-list">
          {SOURCES.map((s) => (
            <li key={s.name} data-testid="data-source-item">
              <s.icon size={18} aria-hidden="true" />
              <span><b>{s.name}</b><small>{s.what}</small></span>
            </li>
          ))}
        </ul>
        <p className="mk-trust-foot"><Clock size={14} aria-hidden="true" /> Quotes may be delayed. <a href="/data-sources">How we handle data</a></p>
      </div>
    </div>
  </section>
);
